import * as React from 'react';
import { addMonths, format, getMonth, getYear, parseISO, setMonth, setYear } from 'date-fns';
import { compose } from 'recompose';
import { createStyles, Grid, IconButton, MenuItem, Select } from '@material-ui/core';
import { generateYears } from '../../utils';
import { withBaseProps } from '../../../../Utils';
import { FontIcon } from '../../../../FontIcon';
const styles = (theme) => createStyles({
    root: {
        fontSize: theme.font.size.mediumSmall,
    },
    iconContainer: {
        padding: theme.space.padding.smallest,
    },
    icon: {
        padding: theme.space.padding.small,
    },
    select: {
        paddingRight: theme.space.padding.smallest,
        cursor: 'pointer',
    },
    disabled: {
        color: theme.color.font.dark,
    },
    disabledIcon: {
        display: 'none',
    },
});
const DateRangePickerComponentHeader = (props) => {
    const { date, classes, setDate, nextDisabled, prevDisabled, onClickNext, onClickPrevious, theme, disableDropdown = true, yearsToGenerateInDropdown = 10, locale, } = props;
    const monthsArray = Array.from(Array(12).keys()).map((month) => format(addMonths(parseISO('2000-01-01'), month), 'MMM', { locale }));
    const handleMonthChange = (event) => {
        setDate(setMonth(date, parseInt(event.target.value, 10)));
    };
    const handleYearChange = (event) => {
        setDate(setYear(date, parseInt(event.target.value, 10)));
    };
    return (React.createElement(Grid, { container: true, justifyContent: "space-around", alignItems: "center" },
        React.createElement(Grid, { item: true },
            React.createElement(Select, { className: classes.select, classes: { disabled: classes.disabled, icon: classes.disabledIcon, root: classes.root }, value: getMonth(date), disabled: disableDropdown, onChange: handleMonthChange, MenuProps: { disablePortal: true }, disableUnderline: true }, monthsArray.map((month, idx) => (React.createElement(MenuItem, { key: month, value: idx }, month.toUpperCase())))),
            React.createElement(Select, { className: classes.select, value: getYear(date), classes: { disabled: classes.disabled, icon: classes.disabledIcon, root: classes.root }, disabled: disableDropdown, onChange: handleYearChange, MenuProps: { disablePortal: true }, disableUnderline: true }, generateYears(date, yearsToGenerateInDropdown).map((year) => (React.createElement(MenuItem, { key: year, value: year }, year))))),
        React.createElement(Grid, { item: true, className: classes.iconContainer },
            React.createElement(IconButton, { className: classes.icon, disabled: prevDisabled, onClick: onClickPrevious },
                React.createElement(FontIcon, { iconName: "left", color: prevDisabled ? theme.color.grey.light : theme.color.font.dark, size: 16 })),
            React.createElement(IconButton, { className: classes.icon, disabled: nextDisabled, onClick: onClickNext },
                React.createElement(FontIcon, { iconName: "right", color: nextDisabled ? theme.color.grey.light : theme.color.font.dark, size: 16 })))));
};
export default compose(withBaseProps({ styles }))(DateRangePickerComponentHeader);
//# sourceMappingURL=DateRangePickerComponentHeader.js.map